import { render, staticRenderFns } from "./BlockLinksList.vue?vue&type=template&id=5458dc7a&scoped=true&"
import script from "./BlockLinksList.vue?vue&type=script&lang=ts&"
export * from "./BlockLinksList.vue?vue&type=script&lang=ts&"
import style0 from "./BlockLinksList.vue?vue&type=style&index=0&id=5458dc7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5458dc7a",
  null
  
)

export default component.exports